/* kk-promo-deal.js — direct add-to-cart for the main-product `promo_deal` block.
   Same mechanism as the card direct-ATC in snippets/product-card.liquid: KK.cart.add (the only cart
   caller) with cart-drawer + header section re-render, then kk:drawer:open. Delegated on document. */
(function () {
  if (window.__kkPromoDealBound) return;
  window.__kkPromoDealBound = true;
  /* v4.37: line properties of the gift - _promo always, _set when the root carries data-deal-set (Flow order tag set-<flag>). */
  function dealProps(root) {
    var p = { _promo: 'gratis' }, f = root && root.getAttribute ? root.getAttribute('data-deal-set') : null;
    if (f) p._set = f;
    return p;
  }
  /* Promo variant display: when the variant picker hid a single-size tile and pre-checked its "2er Set"
     twin (data-promo-autoselect), fire a change so price / variant id / URL follow the visible tile. */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.kk-vp__radio[data-promo-autoselect]:checked').forEach(function (r) {
      r.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
  /* 2026-09-07: options carrying data-img (collection deals) swap the card image on change. */
  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest ? e.target.closest('[data-deal-variant]') : null;
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var img = opt && opt.getAttribute('data-img');
    if (!img) return;
    var root = sel.closest('[data-deal-root]') || sel.closest('.s-pdp__deal');
    var el = root && root.querySelector('.s-pdp__deal-img, .kk-cart-gift__img');
    if (el) { el.removeAttribute('srcset'); el.src = img; }
  });
  /* 2026-09-07: on load, show the image of the pre-selected option (the card image is the deal product's photo,
     the first dropdown option may be another product) */
  function syncDealImage(sel) {
    var opt = sel.options[sel.selectedIndex]; var img = opt && opt.getAttribute('data-img'); if (!img) return;
    var root = sel.closest('[data-deal-root]') || sel.closest('.s-pdp__deal');
    var el = root && root.querySelector('.s-pdp__deal-img, .kk-cart-gift__img');
    if (el) { el.removeAttribute('srcset'); el.src = img; }
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-deal-variant]').forEach(syncDealImage);
  });
  var FALLBACK = 'Der Artikel konnte nicht hinzugefügt werden. Bitte versuche es erneut.';
  function userMessage(err) {
    if (err && typeof err.userMessage === 'string' && err.userMessage) return err.userMessage;
    if (window.KK && window.KK.i18n && window.KK.i18n.cartAddError) return window.KK.i18n.cartAddError;
    return FALLBACK;
  }
  function setBusy(btn, on) {
    if (on) { btn.__kkPrev = btn.disabled; btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    else { btn.disabled = !!btn.__kkPrev; btn.removeAttribute('aria-busy'); }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-deal-atc]') : null;
    if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    var root = btn.closest('[data-deal-root]') || btn.closest('.s-pdp__deal') || document;
    var select = root.querySelector('[data-deal-variant]');
    var region = root.querySelector('[data-deal-error]');
    var variantId = select ? Number(select.value) : 0;
    if (!variantId) return;
    if (!(window.KK && window.KK.cart)) {            // cart API not loaded → fall back to the product page
      var link = root.querySelector('.s-pdp__deal-link, .s-pdp__deal-media');
      if (link && link.href) window.location.href = link.href;
      return;
    }
    if (region) region.textContent = '';
    setBusy(btn, true);
    try {
      var sections = [];
      var drawer = document.querySelector('cart-drawer[data-section-id]');
      if (drawer) sections.push(drawer.getAttribute('data-section-id'));
      sections.push('header');
      /* 2026-09-04: data-deal-add-main = current product's variant id (kept in sync with the picker by the main
         form's hidden [name=id]); add it first, then the deal item, so "Topper + Gratis-Kissen" is one click. */
      var form = root.querySelector('[data-deal-form]');
      var mainId = 0;
      if (form && form.hasAttribute('data-deal-add-main')) {
        var mainForm = document.querySelector('form[action*="/cart/add"] [name="id"], [data-pdp-form] [name="id"]');
        mainId = Number((mainForm && mainForm.value) || form.getAttribute('data-deal-add-main')) || 0;
      }
      var first = mainId ? window.KK.cart.add({ id: mainId, quantity: 1 }, { sections: sections.join(',') }) : Promise.resolve();
      first
        .then(function () { return window.KK.cart.add({ id: variantId, quantity: 1, properties: dealProps(root) }, { sections: sections.join(',') }); })
        .then(function () {
          if (window.KK.pubsub) window.KK.pubsub.publish('kk:drawer:open', { id: 'cart' });
        })
        .catch(function (err) {
          if (region) region.textContent = userMessage(err);
          else console.warn('[kk] promo deal add-to-cart failed', err);
        })
        .finally(function () { setBusy(btn, false); });
    } catch (err) {
      setBusy(btn, false);
      if (region) region.textContent = userMessage(err);
      console.warn('[kk] promo deal add-to-cart could not be started', err);
    }
  });
})();
